import {toBaseScalarPricingPayload} from "@/features/pricing";
import {CreateSessionData} from "../../../../features/sessions";
import {TServiceApiPayload} from "../../../../redux/service/i-service";
import {CreateSessionFormValues} from "../reducers/create-session/types";
import {ServiceFormValues} from "../types";

export function createNewServiceDto(values: ServiceFormValues): TServiceApiPayload {
  const currencies =
    values.callPriceType === "free"
      ? []
      : [
          {
            callPrice: Number(values.callPrice),
            callPriceCurrency: values.callPriceCurrency,
          },
          ...values.currencies,
        ];

  return {
    audioLocation: values.callLocation === "phone" ? true : false,
    callDuration:
      values.callDuration === "-1"
        ? Number(values.customCallDuration)
        : Number(values.callDuration),
    callPrice: values.callPriceType === "free" ? 0 : Number(values.callPrice),
    callPriceCurrency: values.callPriceType === "free" ? "NGN" : values.callPriceCurrency,
    currencies,
    description: values.description,
    hideServiceFromMenu: values.hideServiceFromMenu,
    name: values.name,
    request_phone_number: values.request_phone_number,
    slug: values.slug,
    videoLocation:
      (values.callLocation as string) === "video" ||
      (values.callLocation as string) === "google_meet"
        ? true
        : false,
    hasGoogleMeet: (values.callLocation as string) === "google_meet" ? true : false,
    cover_image: values.cover_image,
    url_redirect: values.isUrlRedirect ? values.url_redirect : undefined,
    enable_currency_conversion: values.callPriceType !== "free",
    selected_currencies: values.selected_currencies || [],
    ...(values.bookingQuestions.length > 0 && {
      bookingQuestions: values.bookingQuestions,
    }),
  };
}
export function createSessionDto(values: CreateSessionFormValues): CreateSessionData {
  const redirectType =
    values.redirectAfterPurchase === "custom-url"
      ? "url"
      : values.redirectAfterPurchase ?? "none";
  return {
    audioLocation: values.callLocation === "phone" ? true : false,
    callDuration:
      values.callDuration === "-1"
        ? Number(values.customCallDuration)
        : Number(values.callDuration),
    // The Pricing Model, the base-currency scalars and the rows. Under Pay What You Want
    // the base row is split out of `currencies` on the way; Free and Single Fee send what
    // they always have.
    ...toBaseScalarPricingPayload(values),
    description: values.description,
    hideServiceFromMenu: values.hideFromProfile,
    name: values.name,
    requestPhoneNumber: values.requestCustomerPhoneNumber,
    slug: values.slug,
    videoLocation: ["video", "google_meet", "zoom"].includes(
      values.callLocation as string
    ),
    hasGoogleMeet: (values.callLocation as string) === "google_meet",
    videoPlatform: values.callLocation === "zoom" ? "zoom" : undefined,
    coverImage: values.coverImage,
    ...(redirectType === "url"
      ? {redirectType, urlRedirect: values.url_redirect, telegramGroupChatId: null}
      : redirectType === "telegram"
      ? {
          redirectType,
          urlRedirect: null,
          telegramGroupChatId: values.telegramGroupId ?? null,
        }
      : {}),
    bookingQuestions:
      values.bookingQuestions.length > 0
        ? values.bookingQuestions.map((q) => {
            if (
              q.answerType === "checkbox" ||
              q.answerType === "dropdown" ||
              q.answerType === "radio-button"
            ) {
              return {
                question: q.question,
                required: q.required,
                answerType: q.answerType,
                options: q.options.map((o) => o.optionLabel),
              };
            } else {
              return {
                question: q.question,
                required: q.required,
                answerType: q.answerType,
              };
            }
          })
        : [],
    availabilityScheduleId: values.availabilityScheduleId,
    enableCurrencyConversion: values.callPriceType !== "free",
    selectedCurrencies:
      values.callPriceType === "free" ? [] : values.selected_currencies || [],
  };
}
